import { assertGraphQLRequestError } from "@myvp/shared/src/functions/mock"
import { subMinutes } from "date-fns"
import {
  VersionStatus,
  StudySiteStatus,
  SiteSignatureDataSource,
} from "src/gql/graphql"
import * as sitesService from "src/pages/study/sites/sites.service"

const listSiteMetricsMock: Record<
  string,
  Awaited<ReturnType<typeof sitesService.listSiteMetrics>>
> = {
  "17557_0ST0000000RE001": {
    siteSummaryMetrics: [
      {
        siteId: "8154a70c-d850-492f-aaf5-b82289efe080",
        siteNumber: "1025",
        country: "United States",
        siteName: "Combos Research Facility",
        versionStatus: VersionStatus.Active,
        version: "1",
        countParticipants: 100,
        eproCompliance: 90,
        eclinroCompliance: 98,
        hasEpro: true,
        hasEclinro: true,
        siteStatus: StudySiteStatus.Active,
      },
      {
        siteId: "75b6b2a1-9620-4331-95d1-7e8b7ff92f28",
        siteNumber: "1026",
        country: "United States",
        siteName: "Bluth's Original Frozen Bananas",
        versionStatus: VersionStatus.ActivePendingTranslations,
        version: "1",
        countParticipants: 250,
        eproCompliance: 93,
        eclinroCompliance: 99.71,
        hasEpro: true,
        hasEclinro: true,
        siteStatus: StudySiteStatus.Locked,
      },
      {
        siteId: "24ac4e7e-5138-4bd7-bfaf-b53e366bca78",
        siteNumber: "1027",
        country: "United States",
        siteName: "Harvard",
        versionStatus: VersionStatus.ActivePendingLanguages,
        version: "2",
        countParticipants: 9,
        eproCompliance: 0,
        eclinroCompliance: 12,
        hasEpro: true,
        hasEclinro: true,
        siteStatus: StudySiteStatus.Archived,
      },
      {
        siteId: "5277e02a-5964-4014-b106-0d84e55e0c50",
        siteNumber: "1028",
        country: "Italy",
        siteName: "University of Bologna",
        versionStatus: VersionStatus.NoVersion,
        countParticipants: 0,
        hasEpro: true,
        hasEclinro: true,
        siteStatus: StudySiteStatus.Active,
      },
      {
        siteId: "140c37b0-167c-4738-8949-ff37d56ec780",
        siteNumber: "1029",
        country: "United States",
        siteName: "Charles River Research",
        versionStatus: VersionStatus.ActivePendingUpdate,
        version: "3",
        countParticipants: 120,
        eproCompliance: 82,
        eclinroCompliance: 92,
        hasEpro: true,
        hasEclinro: true,
        siteStatus: StudySiteStatus.NotActive,
      },
      {
        siteId: "b4bd2c2a-d8c2-4f5b-a39a-0f38411af7dd",
        siteNumber: "1030",
        country: "Japan",
        siteName: "Tsushima Research",
        versionStatus: VersionStatus.PendingActivation,
        countParticipants: 0,
        hasEpro: false,
        hasEclinro: false,
        siteStatus: StudySiteStatus.Active,
      },
      {
        siteId: "25a357a0-1fab-4fa6-98c2-f42e46b1ea6d",
        siteNumber: "1234",
        country: "United States",
        siteName: "Ohio",
        versionStatus: VersionStatus.Active,
        version: "1",
        countParticipants: 0,
        hasEpro: true,
        hasEclinro: false,
        siteStatus: StudySiteStatus.Archived,
      },
    ],
  },
  "17557_0ST0000000RE002": {
    siteSummaryMetrics: [
      {
        siteId: "8154a70c-d850-492f-aaf5-b82289efe080",
        siteNumber: "1025",
        country: "United States",
        siteName: "Combos Research Facility",
        versionStatus: VersionStatus.Active,
        version: "1",
        countParticipants: 100,
        eproCompliance: 90,
        hasEpro: true,
        hasEclinro: false,
        siteStatus: StudySiteStatus.Active,
      },
      {
        siteId: "75b6b2a1-9620-4331-95d1-7e8b7ff92f28",
        siteNumber: "1026",
        country: "United States",
        siteName: "Bluth's Original Frozen Bananas",
        versionStatus: VersionStatus.ActivePendingTranslations,
        version: "1",
        countParticipants: 250,
        eproCompliance: 93,
        hasEpro: true,
        hasEclinro: false,
        siteStatus: StudySiteStatus.Active,
      },
    ],
  },
  "17557_0ST0000000RE003": {
    siteSummaryMetrics: [
      {
        siteId: "8154a70c-d850-492f-aaf5-b82289efe080",
        siteNumber: "1025",
        country: "United States",
        siteName: "Combos Research Facility",
        versionStatus: VersionStatus.Active,
        version: "1",
        countParticipants: 100,
        eclinroCompliance: 98,
        hasEpro: false,
        hasEclinro: true,
        siteStatus: StudySiteStatus.NotActive,
      },
      {
        siteId: "75b6b2a1-9620-4331-95d1-7e8b7ff92f28",
        siteNumber: "1026",
        country: "United States",
        siteName: "Bluth's Original Frozen Bananas",
        versionStatus: VersionStatus.ActivePendingTranslations,
        version: "1",
        countParticipants: 250,
        eclinroCompliance: 99.71,
        hasEpro: false,
        hasEclinro: true,
        siteStatus: StudySiteStatus.Archived,
      },
    ],
  },
  "17557_0ST0000000RE004": {
    siteSummaryMetrics: [],
  },
}

export const listSiteMetrics: typeof sitesService.listSiteMetrics = async (
  globalSponsorStudyId
) => {
  assertGraphQLRequestError(listSiteMetricsMock[globalSponsorStudyId])
  return listSiteMetricsMock[globalSponsorStudyId]
}

export const getSiteAndParticipantMetrics: typeof sitesService.getSiteAndParticipantMetrics =
  async (args) => {
    const mockEproParticipantMetrics: Awaited<
      ReturnType<typeof sitesService.getSiteAndParticipantMetrics>
    >["siteParticipantMetrics"]["eproParticipantMetrics"] = [
      {
        participantId: "5266ebc7-08f6-4184-889e-1e206b47d3ab",
        participantNumber: "1",
        completedSurveysPercent: 90,
        completedSurveys: 9,
        totalSurveys: 10,
        totalAvailableSurveys: 10,
        countAvailableLessThanWeek: 1,
        countAvailableMoreThanWeek: 9,
      },
      {
        participantId: "uuid-inactive",
        participantNumber: "2",
        completedSurveysPercent: 79.5,
        completedSurveys: 8,
        totalSurveys: 10,
        totalAvailableSurveys: 10,
        countAvailableLessThanWeek: 2,
        countAvailableMoreThanWeek: 8,
      },
      {
        participantId: "463de993-3d11-48b8-8748-cad14741eb0f",
        participantNumber: "3",
        completedSurveysPercent: 100,
        completedSurveys: 10,
        totalSurveys: 10,
        totalAvailableSurveys: 10,
        countAvailableLessThanWeek: 3,
        countAvailableMoreThanWeek: 7,
      },
    ]

    const mockEclinroParticipantMetrics: Awaited<
      ReturnType<typeof sitesService.getSiteAndParticipantMetrics>
    >["siteParticipantMetrics"]["eproParticipantMetrics"] = [
      {
        participantId: "b7975dd9-19c7-48ef-b036-a33a631da742",
        participantNumber: "1",
        completedSurveysPercent: 90,
        completedSurveys: 18,
        totalSurveys: 20,
        totalAvailableSurveys: 20,
        countAvailableLessThanWeek: 11,
        countAvailableMoreThanWeek: 9,
      },
      {
        participantId: "632c545f-e308-45ec-93d7-8b42adebfa3c",
        participantNumber: "2",
        completedSurveysPercent: 1,
        completedSurveys: 20,
        totalSurveys: 20,
        totalAvailableSurveys: 20,
        countAvailableLessThanWeek: 12,
        countAvailableMoreThanWeek: 8,
      },
      {
        participantId: "fe437872-1acd-4f56-8614-ccb7a3b1fbd7",
        participantNumber: "3",
        completedSurveysPercent: 1,
        completedSurveys: 20,
        totalSurveys: 20,
        totalAvailableSurveys: 20,
        countAvailableLessThanWeek: 13,
        countAvailableMoreThanWeek: 7,
      },
    ]

    const mockParticipantSignatureMetrics: Awaited<
      ReturnType<typeof sitesService.getSiteAndParticipantMetrics>
    >["siteParticipantMetrics"]["participantSignatureMetrics"] = [
      {
        studyParticipantId: "b7975dd9-19c7-48ef-b036-a33a631da742",
        participantNumber: "1",
        signatureMetricsByDataSource: [
          {
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.Transcription,
            percentSurveysSigned: 25,
            countSurveysSigned: 25,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEpro,
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEclinro,
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
        ],
      },
      {
        studyParticipantId: "632c545f-e308-45ec-93d7-8b42adebfa3c",
        participantNumber: "2",
        signatureMetricsByDataSource: [
          {
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.Transcription,
            percentSurveysSigned: 25,
            countSurveysSigned: 25,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEpro,
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEclinro,
            percentSurveysSigned: 75,
            countSurveysSigned: 75,
            countSurveysRequiringSignature: 100,
          },
        ],
      },
      {
        studyParticipantId: "fe437872-1acd-4f56-8614-ccb7a3b1fbd7",
        participantNumber: "3",
        signatureMetricsByDataSource: [
          {
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.Transcription,
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEpro,
            percentSurveysSigned: 50,
            countSurveysSigned: 50,
            countSurveysRequiringSignature: 100,
          },
          {
            dataSource: SiteSignatureDataSource.SourceEclinro,
            percentSurveysSigned: 75,
            countSurveysSigned: 75,
            countSurveysRequiringSignature: 100,
          },
        ],
      },
    ]

    const getSiteAndParticipantMetricsMock: Record<
      string,
      Awaited<ReturnType<typeof sitesService.getSiteAndParticipantMetrics>>
    > = {
      default: {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1028",
            versionStatus: VersionStatus.NoVersion,
            countParticipants: 0,
            completedSurveys: 0,
            hasEpro: true,
            hasEclinro: true,
            countSupportedLanguages: 0,
            supportedLanguages: [],
            countAvailableEclinroSurveys: 0,
            countAvailableEproSurveys: 0,
            countParticipantsWithSignaturesComplete: 0,
            countParticipantsWithSignaturesRequired: 0,
            percentCompletedSignaturesByDataSource: [],
          },
          eproParticipantMetrics: [],
          eclinroParticipantMetrics: [],
          participantSignatureMetrics: [],
        },
      },
      "5277e02a-5964-4014-b106-0d84e55e0c50": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1028",
            versionStatus: VersionStatus.NoVersion,
            countParticipants: 0,
            completedSurveys: 0,
            hasEpro: true,
            hasEclinro: true,
            countSupportedLanguages: 0,
            supportedLanguages: [],
            countAvailableEclinroSurveys: 0,
            countAvailableEproSurveys: 0,
            countParticipantsWithSignaturesComplete: 0,
            countParticipantsWithSignaturesRequired: 0,
            percentCompletedSignaturesByDataSource: [],
          },
          eproParticipantMetrics: [],
          eclinroParticipantMetrics: [],
          participantSignatureMetrics: [],
        },
      },
      "8154a70c-d850-492f-aaf5-b82289efe080": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1025",
            versionStatus: VersionStatus.Active,
            version: "1",
            countParticipants: 100,
            eproCompliance: 90,
            eclinroCompliance: 97,
            hasEpro: true,
            hasEclinro: true,
            countSupportedLanguages: 4,
            supportedLanguages: ["en-US", "es-ES", "fr-FR", "de-DE"],
            completedSurveys: 50,
            countAvailableEclinroSurveys: 26,
            countAvailableEproSurveys: 24,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: mockEproParticipantMetrics,
          eclinroParticipantMetrics: mockEclinroParticipantMetrics,
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "75b6b2a1-9620-4331-95d1-7e8b7ff92f28": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1026",
            versionStatus: VersionStatus.ActivePendingTranslations,
            version: "1",
            countParticipants: 250,
            eproCompliance: 93,
            eclinroCompliance: 99.71,
            hasEpro: true,
            hasEclinro: true,
            completedSurveys: 30,
            countSupportedLanguages: 1,
            countAvailableEclinroSurveys: 12,
            countAvailableEproSurveys: 13,
            supportedLanguages: ["en-US"],
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: mockEproParticipantMetrics,
          eclinroParticipantMetrics: mockEclinroParticipantMetrics,
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "24ac4e7e-5138-4bd7-bfaf-b53e366bca78": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1027",
            countSupportedLanguages: 1,
            supportedLanguages: ["en-US"],
            versionStatus: VersionStatus.ActivePendingLanguages,
            version: "2",
            countParticipants: 9,
            eproCompliance: 0,
            eclinroCompliance: 12,
            hasEpro: true,
            hasEclinro: true,
            completedSurveys: 1720,
            countAvailableEclinroSurveys: 1,
            countAvailableEproSurveys: 2,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: mockEproParticipantMetrics,
          eclinroParticipantMetrics: mockEclinroParticipantMetrics,
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "140c37b0-167c-4738-8949-ff37d56ec780": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1029",
            countSupportedLanguages: 1,
            supportedLanguages: ["en-US"],
            versionStatus: VersionStatus.ActivePendingUpdate,
            version: "3",
            countParticipants: 120,
            eproCompliance: 82,
            eclinroCompliance: 92,
            hasEpro: true,
            hasEclinro: true,
            completedSurveys: 10,
            countAvailableEclinroSurveys: 21,
            countAvailableEproSurveys: 31,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: mockEproParticipantMetrics,
          eclinroParticipantMetrics: mockEclinroParticipantMetrics,
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "b4bd2c2a-d8c2-4f5b-a39a-0f38411af7dd": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "1030",
            countSupportedLanguages: 2,
            supportedLanguages: ["en-US", "ja-JP"],
            versionStatus: VersionStatus.PendingActivation,
            countParticipants: 0,
            hasEpro: false,
            hasEclinro: false,
            completedSurveys: 0,
            countAvailableEclinroSurveys: 0,
            countAvailableEproSurveys: 0,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: [],
          eclinroParticipantMetrics: [],
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "a9268fff-827a-4316-a431-54cb609e845e": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "2048",
            countSupportedLanguages: 1,
            supportedLanguages: ["en-US"],
            versionStatus: VersionStatus.Active,
            countParticipants: 80,
            version: "2",
            hasEpro: true,
            hasEclinro: false,
            completedSurveys: 231,
            eproCompliance: 83,
            countAvailableEclinroSurveys: 32,
            countAvailableEproSurveys: 43,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: mockEproParticipantMetrics,
          eclinroParticipantMetrics: [],
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
      "c3482784-b6b8-4717-b0d5-b19ca8bf2c08": {
        settings: { threshold: 80 },
        generatedAt: subMinutes(new Date(), 10).toISOString(),
        siteParticipantMetrics: {
          siteSummaryMetrics: {
            siteNumber: "2049",
            countSupportedLanguages: 1,
            supportedLanguages: ["en-US"],
            versionStatus: VersionStatus.ActivePendingTranslations,
            countParticipants: 200,
            version: "1",
            hasEpro: false,
            hasEclinro: true,
            completedSurveys: 1000,
            eclinroCompliance: 99.3,
            countAvailableEclinroSurveys: 222,
            countAvailableEproSurveys: 333,
            countParticipantsWithSignaturesComplete: 50,
            countParticipantsWithSignaturesRequired: 100,
            percentCompletedSignaturesByDataSource: [
              {
                dataSource: SiteSignatureDataSource.Transcription,
                percentage: 25,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEpro,
                percentage: 50,
              },
              {
                dataSource: SiteSignatureDataSource.SourceEclinro,
                percentage: 25,
              },
            ],
          },
          eproParticipantMetrics: [],
          eclinroParticipantMetrics: mockEclinroParticipantMetrics,
          participantSignatureMetrics: mockParticipantSignatureMetrics,
        },
      },
    }

    const response =
      getSiteAndParticipantMetricsMock[args.siteId] ??
      getSiteAndParticipantMetricsMock.default

    assertGraphQLRequestError(response)
    return response
  }

export const sitesMock = {
  listSiteMetricsMock,
}
